const domain = process.env.REACT_APP_THINKIFIC_ENDPOINT;
const ERROR_MESSAGES = {
  EMAIL_REQUIRED: 'Email is required',
  DOMAIN_REQUIRED: 'Thinkific URL is required',
  DOMAIN_INVALID: `Invalid domain format. Should be: your-domain.${domain}`,
  PASSWORD_REQUIRED: 'Password is required',
  PASSWORD_INVALID: 'Please enter a valid password. Minimum 6 characters.',
  WRONG_EMAIL_FORMAT: 'Invalid email format.',
};
const { REACT_APP_THINKIFIC_ENDPOINT } = process.env;
export const RECOVERY_PASSWORD_URL = `https://courses.${REACT_APP_THINKIFIC_ENDPOINT}/forgot_password`;
export default ERROR_MESSAGES;
